import styled from "@emotion/styled";
import { DialogCloseButton } from "../dialog/DialogCloseButton";

// 3rem × 3rem hit target, slightly lower so the icon optically aligns with the
// dialog heading. Extends the shared base button so positioning + chrome stay
// in sync with other dialog flavors.
export const PopupDialogCloseButton = styled(DialogCloseButton)`
  top: 0.6rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
